import type { Scalars } from '@change-corgi/middle-end-gql-schema';

type ExperimentsWithEndorsements = {
	starterExperienceDashboardEndorsementsExperiment: Scalars['EXPERIMENT_STARTER_EXPERIENCE_DASHBOARD_ENDORSEMENTS_EXPERIMENT']['output'];
};

/**
 * Hook to determine if the endorsements feature is enabled.
 *
 * This hook reads the experiment variation to check if the starter experience
 * dashboard endorsements feature is enabled. The feature is enabled when
 * the experiment variation is 'enabled' (vs 'control').
 *
 * @param experiments - The experiments object from viewer/page data context
 * @returns Object with isEnabled boolean indicating if endorsements are enabled
 *
 * @example
 * ```tsx
 * const { data: { viewer } } = usePageData();
 * const { isEnabled } = useEndorsementsFeature(viewer.experiments);
 * ```
 */
export function useEndorsementsFeature(experiments: ExperimentsWithEndorsements): { isEnabled: boolean } {
	const experiment = experiments.starterExperienceDashboardEndorsementsExperiment;
	const isEnabled = experiment.variation === 'enabled';

	return {
		isEnabled,
	};
}
